import styles from "./StreamPreview.module.css";
import Icon from "../Icon";
import { FaVideoSlash } from "react-icons/fa";

export default function StreamPreview({ videoPermissions, canvasRef }) {
  return (
    <div className={styles.streamPreviewContainer}>
      <div className={styles.streamPreview}>
        <canvas
          key="STREAM_PREVIEW_VIDEO"
          id="cam-video-preview"
          className={styles.streamPreviewVideo}
          ref={canvasRef}
        ></canvas>
        {videoPermissions ? (
          <></>
        ) : (
          <div className={styles.needPermissions}>
            <div className="text-center mg-bottom-10">
              <div className="d-inline-block rounded-circle bg-navyBlue white padding-20">
                <FaVideoSlash className="fs-30" />
              </div>
            </div>
            <p className="fs-22 font-rajdhani">
              To start streaming, allow access to your camera and microphone
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
